<div [ngClass]="{'page-container vf-mobile': url ==='/app/mobile/my-day','page-container-new d-flex': url !=='/app/mobile/my-day'}">

    <!-- ═══ New sidebar ═══ (none on a full-screen route: /app/onboarding, the old welcome — OB-G-12) -->
    <div class="side-menu-left d-flex flex-column"
        [class.expanded]="!isMenuCollapsed"
        *ngIf="url !=='/app/mobile/my-day' && !isFullScreenRoute">

        <!-- Header row -->
        <div class="sidebar-header">
            <img src="https://cdn.trovve.com/trovve/login-left-logo.png" alt="Trovve"
                class="sidebar-logo show-in-expanded">
            <button (click)="toggleMenu()" [title]="isMenuCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
                class="sidebar-collapse-btn">
                <lucide-icon [name]="isMenuCollapsed ? 'panel-left-open' : 'panel-left-close'" [size]="16" [strokeWidth]="1.5"></lucide-icon>
            </button>
        </div>

        <!-- Create new section -->
        <div class="sidebar-create-section">
            <button class="sidebar-create-btn" (click)="toggleCreateDropdown()">
                <lucide-icon name="plus" [size]="16" [strokeWidth]="2"></lucide-icon>
                <span class="show-in-expanded sidebar-create-label">Create new</span>
                <lucide-icon name="chevron-down" [size]="14" [strokeWidth]="2" class="show-in-expanded sidebar-create-chevron"></lucide-icon>
            </button>
            <!-- Create dropdown -->
            <div *ngIf="showCreateDropdown" class="sidebar-create-dropdown">
                <button class="sidebar-create-dropdown-item" (click)="createAction('task')">
                    <lucide-icon name="square-check-big" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon><span>Task</span>
                </button>
                <button *ngIf="showCalendarNav" class="sidebar-create-dropdown-item" (click)="createAction('event')">
                    <lucide-icon name="calendar-plus" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon><span>Event</span>
                </button>
                <button class="sidebar-create-dropdown-item" (click)="createAction('project')">
                    <lucide-icon name="briefcase" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon><span>{{projectLabel}}</span>
                </button>
                <div class="sidebar-dropdown-divider"></div>
                <button class="sidebar-create-dropdown-item" (click)="createAction('person')">
                    <lucide-icon name="user" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon><span>Person</span>
                </button>
                <button class="sidebar-create-dropdown-item" (click)="createAction('company')">
                    <lucide-icon name="building-2" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon><span>Company</span>
                </button>
            </div>
            <div *ngIf="showCreateDropdown" class="sidebar-create-backdrop" (click)="closeCreateDropdown()"></div>
        </div>

        <!-- Scrollable nav area -->
        <div class="sidebar-nav-scroll">
            <!-- Main nav group -->
            <div class="sidebar-nav-group">
                <button class="sidebar-nav-item" [class.active]="isNavActive('/app/main/my-day')" (click)="navigateMenu('/app/main/my-day')" data-tooltip="My day">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="sun" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                        <span class="sidebar-badge-dot count-in-slim" *ngIf="newTaskCount && newTaskCount !== '0'"></span>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">My day</span>
                    <span class="sidebar-badge count-in-expanded" *ngIf="newTaskCount && newTaskCount !== '0'">{{newTaskCount}}</span>
                </button>
                <!-- Tasks — the cross-project incomplete-task list. Icons and order are the design's (handoff (12), Trovve.dc.html
                     sidebar: My day, Tasks, Projects, Calendar, Clients, Pipeline). It was the "Incomplete tasks" tab
                     on the projects page until 2026-09-17; it sits with the other task surfaces now. -->
                <button class="sidebar-nav-item" [class.active]="isNavActive('/app/main/tasks')" (click)="menuNavigate('/app/main/tasks')" data-tooltip="Tasks">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="square-check" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">Tasks</span>
                </button>
                <button class="sidebar-nav-item" [class.active]="isNavActive('/app/main/projects')" (click)="menuNavigate('/app/main/projects')" [attr.data-tooltip]="projectLabelPlural">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="briefcase" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">{{projectLabelPlural}}</span>
                </button>
                <button *ngIf="showCalendarNav" class="sidebar-nav-item" [class.active]="isNavActive('/app/main/calendar')" (click)="menuNavigate('/app/main/calendar')" data-tooltip="Calendar">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="calendar" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">Calendar</span>
                </button>
                <!-- <button class="sidebar-nav-item" (click)="openCalendar()" data-tooltip="Meetings">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="video" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                        <span class="sidebar-badge-dot count-in-slim" *ngIf="todayMeetingsCount > 0"></span>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">Meetings</span>
                    <span class="sidebar-badge count-in-expanded" *ngIf="todayMeetingsCount > 0">{{todayMeetingsCount}}</span>
                </button> -->
                <button class="sidebar-nav-item" [class.active]="isNavActive('/app/main/clients')" (click)="menuNavigate('/app/main/clients')" data-tooltip="Clients">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="users" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">Clients</span>
                </button>
                <!-- Lead Pipeline board, a page of its own since handoff (12) (it was the Clients page's third pill). Flag off: no item. -->
                <button *ngIf="showPipelineNav" class="sidebar-nav-item" [class.active]="isNavActive('/app/main/pipeline')" (click)="menuNavigate('/app/main/pipeline')" data-tooltip="Pipeline">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="kanban" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">Pipeline</span>
                </button>
            </div>

            <div class="sidebar-divider"></div>

            <!-- Work group: Conversations, then Search (handoff (12); the design's Ask Leo between them is not in the app) -->
            <div class="sidebar-nav-group">
                <button *ngIf="showConversationsNav" type="button" class="sidebar-nav-item" [class.active]="conversationsOpen$ | async"
                        (click)="openConversations()" data-tooltip="Conversations">
                    <ng-container *ngIf="conversationsBadge$ | async as badge">
                        <div class="sidebar-nav-icon-wrap">
                            <lucide-icon name="message-square" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                            <span class="sidebar-badge-dot count-in-slim" *ngIf="badge.visible"></span>
                        </div>
                        <span class="sidebar-nav-label show-in-expanded">Conversations</span>
                        <span class="sidebar-badge count-in-expanded" *ngIf="badge.visible" [attr.aria-label]="badge.ariaLabel">{{ badge.text }}</span>
                    </ng-container>
                </button>
                <button class="sidebar-nav-item" (click)="openGlobalSearch()" data-tooltip="Search">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="search" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">Search</span>
                </button>
                <!-- <button class="sidebar-nav-item" (click)="openFiles()" data-tooltip="Resources">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="globe" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                    <span class="sidebar-nav-label show-in-expanded">Resources</span>
                </button> -->
            </div>

            <div class="sidebar-divider"></div>

            <!-- Favorites section -->
            <div class="sidebar-favorites show-in-expanded">
                <div class="sidebar-favorites-header">
                    <span class="sidebar-section-label">FAVORITES</span>
                    <button class="sidebar-fav-manage-btn" (click)="toggleFavAddMenu($event)"
                        title="Add a favorite" aria-label="Add a favorite" aria-haspopup="menu"
                        [attr.aria-expanded]="showFavAddMenu">
                        <lucide-icon name="plus" [size]="14" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </button>
                    <!-- Anchored to the + itself, as in the design — not buried inside the manager -->
                    <ng-container *ngIf="showFavAddMenu">
                        <div class="sidebar-fav-addmenu-backdrop" (click)="showFavAddMenu = false"></div>
                        <div class="sidebar-fav-addmenu" role="menu" [ngStyle]="favAddMenuStyle">
                            <p class="sidebar-fav-addmenu-label">Add to favorites</p>
                            <button *ngFor="let t of favAddTypes; trackBy: trackByFavAddType" role="menuitem"
                                class="sidebar-fav-addmenu-item" [disabled]="t.disabled"
                                [title]="t.hint || ''" (click)="pickFavoriteAddType(t)">
                                <lucide-icon [name]="t.icon" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                                <span>{{t.label}}</span>
                            </button>
                        </div>
                    </ng-container>
                </div>
                <!-- One flat list in the user's order — no sections. The hairline between rows is a
                     separator, not a group boundary: it falls between every adjacent pair. -->
                <ng-container *ngIf="favPreview.length > 0">
                    <!-- Drag container: nothing in here but rows. dragulaModel pairs each child element
                         with the item at the same index, so the separators that used to be interleaved
                         <div>s are drawn by the row itself now (.sidebar-fav-item + .sidebar-fav-item),
                         which also keeps them correct after a drop reorders the DOM. -->
                    <div class="sidebar-fav-list" [dragula]="'sidebarFavoritesDragula'" [(dragulaModel)]="favPreview">
                    <button class="sidebar-fav-item" *ngFor="let item of favPreview; trackBy: trackByFavItem"
                        (click)="menuOpenFavItem(item)"
                        (mouseenter)="showFavTip($event, item)" (mouseleave)="hideFavTip()">
                        <!-- Drag anywhere on the row; the grip says so. Hidden until the row is hovered,
                             as the design has it — the side menu is a navigation list first. -->
                        <span class="sidebar-fav-grip" aria-hidden="true">
                            <lucide-icon name="grip-vertical" [size]="14" [strokeWidth]="2" class="no-fill"></lucide-icon>
                        </span>
                        <!-- project -->
                        <lucide-icon *ngIf="item._favKind === 'project'" name="briefcase" [size]="16" [strokeWidth]="2" class="sidebar-fav-icon no-fill"></lucide-icon>
                        <!-- client -->
                        <lucide-icon *ngIf="item._favKind === 'client'" [name]="item._type === 'company' ? 'building-2' : 'user'" [size]="16" [strokeWidth]="2" class="sidebar-fav-icon no-fill"></lucide-icon>
                        <!-- file / folder -->
                        <div class="d-flex align-items-center flex-shrink-0 sidebar-fav-icon" *ngIf="item._favKind === 'file'">
                            <lucide-icon name="file-text" [size]="16" class="text-gray-500"
                                *ngIf="!getListExtension(item.extension) && !isFavFolderItem(item) && !isFavImageItem(item) && item.driveId && item.keyId">
                            </lucide-icon>
                            <lucide-icon name="image" [size]="16" class="text-gray-500"
                                *ngIf="isFavImageItem(item)">
                            </lucide-icon>
                            <lucide-icon name="folder" [size]="16" class="text-gray-500"
                                *ngIf="item.extension === 'documentLibrary'"></lucide-icon>
                            <lucide-icon name="folder" [size]="16" class="text-gray-500"
                                *ngIf="item.extension === 'folder' || (!item.extension && item.keyId && item.driveId)"></lucide-icon>
                            <img [src]="getListExtension(item.extension)"
                                *ngIf="getListExtension(item.extension) && item.extension !== 'documentLibrary' && item.extension !== 'folder'"
                                class="w-16" alt="">
                        </div>
                        <!-- app -->
                        <ng-container *ngIf="item._favKind === 'app'">
                            <img *ngIf="item.appIconUrl" [src]="item.appIconUrl" class="sidebar-fav-app-icon" alt="" />
                            <lucide-icon *ngIf="!item.appIconUrl" name="layout-grid" [size]="16" [strokeWidth]="2" class="sidebar-fav-icon no-fill"></lucide-icon>
                        </ng-container>
                        <!-- link -->
                        <ng-container *ngIf="item._favKind === 'link'">
                            <img *ngIf="item.appIconUrl" [src]="item.appIconUrl" class="sidebar-fav-app-icon" alt="" />
                            <lucide-icon *ngIf="!item.appIconUrl" name="globe" [size]="16" [strokeWidth]="2" class="sidebar-fav-icon no-fill"></lucide-icon>
                        </ng-container>
                        <span class="sidebar-fav-name">{{item.projectName || item.name || item.documentName}}</span>
                    </button>
                    </div>
                    <!-- Outside the drag container on purpose: it is not a favorite and must not be a
                         drop target. -->
                    <!-- Only when the flat order actually hides something past the top 8 -->
                    <!-- <button class="sidebar-fav-seeall" *ngIf="hasHiddenFavorites" (click)="openShortcut()" title="See all favorites">-->
                        <button class="sidebar-fav-seeall" (click)="openShortcut()" title="See all favorites">
                        <span>See all {{favTotal}}</span>
                        <lucide-icon name="chevron-right" [size]="15" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </button>
                </ng-container>
                <!-- Empty state -->
                <div class="sidebar-fav-empty" *ngIf="favPreview.length === 0 && !isFavOrderLoading">
                    <lucide-icon name="star" [size]="16" class="no-fill" style="color:#9ca3af;"></lucide-icon>
                    <span>No favorites yet</span>
                </div>

                <!-- Hover callout for the row above. One element for the whole list rather than one per
                     row: only one can be open, and it is positioned from the hovered row's rect anyway.
                     Separators are rendered between the parts as in the manager's row, so a long trail
                     wraps between segments instead of mid-name. -->
                <div class="sidebar-fav-tip" *ngIf="favTipItem" [ngStyle]="favTipStyle">
                    <p class="sidebar-fav-tip-name">{{favTipItem.projectName || favTipItem.name || favTipItem.documentName}}</p>
                    <p class="sidebar-fav-tip-crumbs" *ngIf="favTipItem._favSegments">
                        <ng-container *ngFor="let s of favTipItem._favSegments; let i = index; trackBy: trackByFavTipCrumb">
                            <span *ngIf="i > 0">&nbsp;›&nbsp;</span><span>{{s}}</span>
                        </ng-container>
                    </p>
                </div>
            </div>

            <!-- Collapsed favorites icon -->
            <div class="sidebar-nav-group count-in-slim">
                <button class="sidebar-nav-item" (click)="openShortcut()" data-tooltip="Favorites">
                    <div class="sidebar-nav-icon-wrap">
                        <lucide-icon name="star" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    </div>
                </button>
            </div>
        </div>

        <!-- Active timer indicator -->
        <vf-sidebar-timer-indicator></vf-sidebar-timer-indicator>

        <!-- New version available banner -->
        <div class="show-in-expanded" *ngIf="updateAvailable" style="flex-shrink:0;overflow:hidden;">
            <div style="margin:0 8px 8px;border-radius:6px;display:flex;align-items:flex-start;gap:10px;padding:10px 12px;background:rgb(239,246,255);border:1px solid rgb(191,219,254);">
                <div style="width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px;background:rgb(11,91,171);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path><path d="M21 3v5h-5"></path><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path><path d="M8 16H3v5"></path></svg>
                </div>
                <div style="flex:1 1 auto;min-width:0;">
                    <p style="margin:0;font-size:12px;font-weight:600;color:rgb(17,24,39);line-height:1.25;">New version ready</p>
                    <p style="margin:2px 0 0;font-size:12px;color:rgb(107,114,128);line-height:1.375;">Refresh to get the latest.</p>
                    <div style="display:flex;align-items:center;gap:8px;margin-top:8px;">
                        <button type="button" (click)="refreshForUpdate()" style="height:24px;border:none;border-radius:4px;color:#fff;font-size:12px;font-weight:500;padding:0 10px;background:rgb(3,2,19);cursor:pointer;">Refresh</button>
                        <button type="button" (click)="dismissUpdate()" style="height:24px;border:none;border-radius:4px;padding:0 6px;font-size:12px;color:rgb(107,114,128);background:transparent;cursor:pointer;">Later</button>
                    </div>
                </div>
                <button type="button" (click)="dismissUpdate()" aria-label="Dismiss update notification" style="flex-shrink:0;margin-top:2px;color:rgb(156,163,175);background:transparent;border:none;padding:0;cursor:pointer;line-height:0;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                </button>
            </div>
        </div>

        <!-- Get help (design: Trovve.dc.html "help & setup" slot). Outside .sidebar-nav-scroll on purpose, so on short
             screens it stays put while the menu items scroll. Opens a drop-up menu: "Submit support ticket" opens a draft
             to help@trovve.com in the user's own mail app (Outlook on the web inside Teams; it never reopens the banner
             form) and "Watch videos" opens the Trovve YouTube channel in a new tab. Hidden while My Day's introduction
             banner is up; the banner's ? icon flies here when it moves, and the item is highlighted for 2 s. -->
        <div class="sidebar-get-help" *ngIf="getHelpMenuVisible$ | async"
            [class.sidebar-get-help--landing]="getHelpMenuLanding$ | async">
            <button type="button" class="sidebar-get-help-btn" data-tooltip="Get help"
                #helpActionsPopover="ngbPopover" [ngbPopover]="helpActions" placement="right-bottom">
                <span class="sidebar-get-help-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg>
                </span>
                <span class="sidebar-get-help-label show-in-expanded">Get help</span>
            </button>
            <!-- Get help menu, opening to the right of the button with its bottom edge level with the button's (same look
                 as the profile menu). Inside the *ngIf so #helpActionsPopover is in scope. -->
            <ng-template #helpActions>
                <div class="vf-pmenu vf-pmenu--help">
                    <div class="vf-pmenu-group">
                        <button type="button" class="vf-pmenu-item" (click)="openContactSupport(); helpActionsPopover.close()">
                            <lucide-icon name="message-square" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                            <span>Submit support ticket</span>
                        </button>
                        <button type="button" class="vf-pmenu-item" (click)="openHelpVideos(); helpActionsPopover.close()">
                            <lucide-icon name="video" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                            <span>Watch videos</span>
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>

        <!-- The help banner's ? icon flying into Get help (design `hlp.flyer`). -->
        <div class="sidebar-get-help-flyer" *ngIf="getHelpFlight$ | async as flight" aria-hidden="true"
            [style.left.px]="flight.left" [style.top.px]="flight.top" [style.--dx]="flight.dx" [style.--dy]="flight.dy">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg>
        </div>

        <!-- Profile section -->
        <div class="sidebar-profile-section" #profileSection>
            <button class="sidebar-profile-btn" #profileOptionsButton
                #profileOptionsPopover="ngbPopover" [ngbPopover]="profileActions" placement="top-left"
                (click)="checkUnsavedForPopoverOpen('profileOptions')">
                <img *ngIf="appSession.user.profilePictureUrl" [src]="appSession.user.profilePictureUrl"
                    class="sidebar-profile-avatar" alt="user">
                <span class="sidebar-profile-avatar-initials" *ngIf="!appSession.user.profilePictureUrl">{{getInitials(appSession.user.name + ' ' + appSession.user.surname)}}</span>
                <div class="sidebar-profile-info show-in-expanded">
                    <p class="sidebar-profile-name line-height-1-5">{{appSession.user.name}} {{appSession.user.surname}}</p>
                    <p class="sidebar-profile-org line-height-normal">{{appSession.tenant.name}}</p>
                </div>
                <lucide-icon name="more-vertical" [size]="16" class="sidebar-profile-more show-in-expanded no-fill"></lucide-icon>
            </button>
        </div>
    </div>

    <!-- Profile actions popover template — matches the design's drop-up menu (Trovve.dc.html "drop-up menu"):
         account header, My profile / Connected apps, WORKSPACE, Sign out. Help is no longer here: it is the
         main-menu Get help above the profile. Upgrade and Billing are app-only and keep their existing gates. -->
    <ng-template #profileActions>
        <div class="vf-pmenu">
            <!-- account header -->
            <div class="vf-pmenu-head">
                <img *ngIf="appSession.user.profilePictureUrl" [src]="appSession.user.profilePictureUrl"
                    class="vf-pmenu-avatar" alt="user">
                <span class="vf-pmenu-avatar vf-pmenu-avatar--initials" *ngIf="!appSession.user.profilePictureUrl">{{getInitials(appSession.user.name)}}</span>
                <div class="vf-pmenu-who">
                    <p class="vf-pmenu-name">{{appSession.user.name}} {{appSession.user.surname}}</p>
                    <p class="vf-pmenu-email">{{appSession.user.emailAddress}}</p>
                    <div class="d-flex align-items-center gap-1-5 mt-1" *ngIf="isInTrialPeriod">
                        <lucide-icon name="sparkles" [size]="14" [strokeWidth]="2" class="no-fill" [ngStyle]="{'color': subscriptionDaysLeftCount <= 3 ? '#dc2626' : '#f59e0b', 'width': '14px', 'height': '14px'}"></lucide-icon>
                        <span class="f-size-12" [ngStyle]="{'color': subscriptionDaysLeftCount <= 3 ? '#dc2626' : '#b45309'}">Pro trial</span>
                        <span class="f-size-12 text-gray-400">&middot;</span>
                        <span class="f-size-12" [ngStyle]="{'color': subscriptionDaysLeftCount <= 3 ? '#dc2626' : '#6b7280', 'font-weight': subscriptionDaysLeftCount <= 3 ? '600' : '400'}">{{subscriptionDaysLeftCount}} {{subscriptionDaysLeftLabel}} left<span *ngIf="subscriptionDaysLeftCount <= 3">!</span></span>
                    </div>
                </div>
            </div>
            <!-- Upgrade button (trial only, billing admins: Owner and Admin) -->
            <div class="vf-pmenu-upgrade" *ngIf="isInTrialPeriod && canManageBilling">
                <button class="btn btn-primary w-100 d-flex align-items-center justify-content-center f-size-14 py-2 rounded-8"
                    (click)="openUpgradeModal(); profileOptionsPopover?.close()">
                    <lucide-icon name="zap" [size]="16" [strokeWidth]="2" class="mr-2 no-fill"></lucide-icon>
                    Upgrade
                </button>
            </div>
            <!-- account items -->
            <div class="vf-pmenu-group">
                <button type="button" class="vf-pmenu-item" (click)="openProfile(true)">
                    <lucide-icon name="user" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>My profile</span>
                </button>
                <button type="button" class="vf-pmenu-item" (click)="openConnectedApps()">
                    <lucide-icon name="link" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Connected apps</span>
                </button>
            </div>
            <!-- workspace -->
            <div class="vf-pmenu-group vf-pmenu-group--rule">
                <p class="vf-pmenu-label">Workspace</p>
                <button type="button" class="vf-pmenu-item" *ngIf="permission.isGranted('Pages.Settings')"
                    (click)="removeBodyClasses();routeToSettings()">
                    <lucide-icon name="user-plus" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Manage users</span>
                </button>
                <button type="button" class="vf-pmenu-item" (click)="removeBodyClasses();routeToCompanySettings()">
                    <lucide-icon name="settings" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Company settings</span>
                </button>
                <!-- Organization Intelligence (D18, IN-N-01): every user; read-only without Pages.Settings (IN-N-02). -->
                <button type="button" class="vf-pmenu-item" (click)="removeBodyClasses();routeToIntelligence()">
                    <lucide-icon name="sparkles" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Intelligence</span>
                </button>
                <button type="button" class="vf-pmenu-item"
                    *ngIf="emailAutomationFeatureEnabled && permission.isGranted('Pages.Settings')"
                    (click)="removeBodyClasses();routeToEmailAutomation()">
                    <lucide-icon name="mail" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Email</span>
                </button>
                <button type="button" class="vf-pmenu-item"
                    *ngIf="calendarV1FeatureEnabled && permission.isGranted('Pages.Settings')"
                    (click)="removeBodyClasses();routeToCalendar()">
                    <lucide-icon name="calendar" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Calendar</span>
                </button>
                <button type="button" class="vf-pmenu-item"
                    *ngIf="canManageBilling && !isInTrialPeriod"
                    (click)="removeBodyClasses();routeToBillingAndPlan()">
                    <lucide-icon name="credit-card" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Billing and plan</span>
                </button>
            </div>
            <!-- sign out -->
            <div class="vf-pmenu-group vf-pmenu-group--rule">
                <button type="button" class="vf-pmenu-item vf-pmenu-item--danger" (click)="signOut()">
                    <lucide-icon name="log-out" [size]="16" [strokeWidth]="2" class="no-fill"></lucide-icon>
                    <span>Sign out</span>
                </button>
            </div>
        </div>
    </ng-template>

    <!-- Main content area -->
    <div [ngClass]="{'w-100': isFullScreenRoute, 'main-grid main-grid-with-right-sidebar': url ==='/app/mobile/my-day','page-main-content bg-pure-white': (url !=='/app/mobile/my-day' && !isFullScreenRoute)}">
        <vf-billing-banner *ngIf="!isFullScreenRoute"></vf-billing-banner>
        <router-outlet></router-outlet>
        <vf-profile-modal #profileModal *ngIf="url !=='/app/mobile/my-day'"></vf-profile-modal>
        <vf-connected-apps-modal #connectedAppsModal *ngIf="url !=='/app/mobile/my-day'"></vf-connected-apps-modal>
    </div>

</div>

<div class="alert fixed-top text-center bg-primary trial-expiration text-white p-2 rounded-0"
    role="alert" *ngIf="!isConnected || refrshBtn">
    <div class="float-left mt-1 d-flex align-middle f-size-14 font-weight-normal">
        {{ refrshBtn ?
        'You lost connection temporarily, please reload to get the latest updates.' :
        'You seem to have lost connection, please check your connection.'
        }}</div>
    <div class="float-right"> <button *ngIf="refrshBtn"
            class="btn bg-primary border-primary text-white hover-shadow rounded-pill mr-2 py-1 px-2 f-size-14"
            (click)="refreshBrowser()">Reload</button>
    </div>

</div>
<div *ngIf="showNewVersion"
    class="trial-expiration alert p-0 text-center bg-primary text-white m-0 rounded-0">
    <div class="float-left mt-1 d-flex align-middle f-size-14 font-weight-bold">
        New version available!
    </div>
    <div class="float-right">
        <button
            class="btn bg-primary border-primary text-white hover-shadow rounded-pill mr-2 py-1 px-2 f-size-14"
            (click)="reloadAppForNewVersion()">Update</button>
    </div>
</div>

<div class="modal fade center-modal trovve-sm-modal" data-keyboard="false" data-backdrop="static" id="UnsavedDataLostModal" tabindex="-1" style="z-index: 5000;">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable w-650">
        <div class="modal-content login-modal bg-popup box-shadow-popup border-all">
            <div class="modal-body text-center pb-4">
                <div class="text-center">
                    <!-- <div class="py-2 d-flex justify-content-center">
                        <ibm-icon-sun size="20" class="rounded-circle border p-10"></ibm-icon-sun>
                    </div> -->
                    <h1 class="f-size-20 tk-montserrat text-vf-dark font-weight-semibold mb-10 mt-20">OOPS!</h1>
                    <p>
                        Are you sure you want to close this form without saving?
                    </p>
                </div>
            </div>
            <div class="modal-footer text-center d-flex p-0">
                <button class="btn cancel-btn rounded-8 py-10 w-100" (click)="closeUnsavedDataLostModal()">No</button>
                <button class="btn btn-black rounded-8 py-10 w-100" (click)="closeUnsavedChangesModal()">Yes</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade center-modal" data-keyboard="false" data-backdrop="static" id="AddTaskUnsavedDataLostModal" tabindex="-1" style="z-index: 5000;">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 500px;">
        <div class="modal-content bg-white p-24" style="border-radius: 10px; border: 1px solid rgb(229, 231, 235); box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);">
            <p class="f-size-16 text-gray-900 font-weight-semibold mb-2 line-height-normal">
                Discard<ng-container *ngIf="addTaskDetails?.taskTitle"> "{{addTaskDetails?.taskTitle}}"</ng-container>?
            </p>
            <p class="f-size-14 text-gray-500 mb-0" style="line-height: 1.6;">
                You've started filling in this task. Closing now will discard your task name and any details you've entered.
            </p>
            <div class="d-flex align-items-center justify-content-end gap-8 mt-4">
                <button type="button"
                    class="vf-modal-cancel-btn"
                    (click)="closeUnsavedChangesModal()">Discard</button>
                <button type="button"
                    class="btn btn-black h-36 px-12 py-10 font-weight-medium d-flex align-items-center gap-4 rounded-sm"
                    (click)="closeUnsavedDataLostModal()">Keep editing</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #upgradeSubscriptionSuccessModal="bs-modal" class="modal fade center-modal" id="requestSubmitSuccessModal"
    tabindex="-1" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content login-modal rounded-10 bg-popup box-shadow-popup border-all">
            <div class="modal-body text-center p-30">
                <img src="https://cdn.trovve.com/vfapp/images/icon-message-check-green.svg"
                    class="mb-20 mt-10 text-center">
                <h1 class="text-museo-sans-rounded font-weight-900 mb-10">Thank you for submitting your request.</h1>
                <p class="f-size-16 mb-30">Someone will be reaching out to you shortly.</p>
                <div class="row m-0 mb-10">
                    <div class="col-3 mx-auto">
                        <a href="javascript:;" class="btn btn-black rounded-8 hover-shadow py-10 text-white"
                            id="upgradeSuccessClose" (click)="closeUpgradeSuccessModal()">Ok</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <vf-upgrade-subscription #upgradeSubscriptionModal (successEmit)="onSuccessUpgrade($event)"> </vf-upgrade-subscription> -->

<!-- Billing pop-ups (story "Stripe Renewals and Upgrade Pop-up", design "Upgrade and Trial Ended.dc.html" 1a-1d, 1f):
     upgrade, trial ended / paused / ended (blocking), confirming payment. Replaces the old upgrade-plan modal and card forms. -->
<vf-billing-gate></vf-billing-gate>

<!-- Adaptive Onboarding handoff into My Day (D17): one host outside the routed area, so it spans the route change from
     /app/onboarding to My Day. P0-13-b places the stub; B-11 fills it (OnboardingHandoffService drives it). -->
<vf-onboarding-handoff-overlay></vf-onboarding-handoff-overlay>

<!-- Pin Onboarding Modal - 2 popup design (never over a full-screen route such as /app/onboarding) -->
<ng-container *ngIf="showPinOBModal && !isFullScreenRoute">
    <!-- Backdrop overlay -->
    <div class="pin-ob-backdrop" (click)="closePinOBModal()"></div>

    <!-- Side popup - Pin to Teams tooltip (positioned next to sidebar) -->
    <div class="pin-ob-side-popup" *ngIf="isIframe">
        <div class="d-flex align-items-center">
            <div class="pin-ob-arrow"></div>
            <div class="pin-ob-side-card">
                <button class="pin-ob-side-close" aria-label="Dismiss" (click)="closePinOBModal()">
                    <lucide-icon name="x" [size]="12" [strokeWidth]="2"></lucide-icon>
                </button>
                <div class="d-flex align-items-center mb-10">
                    <div class="pin-ob-side-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 17v5"></path>
                            <path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"></path>
                        </svg>
                    </div>
                    <span class="f-size-14 text-white font-weight-medium">Pin Trovve to Teams</span>
                </div>
                <div class="mb-3">
                    <div class="d-flex align-items-start mb-8">
                        <div class="pin-ob-step-num flex-shrink-0">1</div>
                        <p class="f-size-12 mb-0" style="color: rgba(255,255,255,0.75); line-height: 1.5;">
                            Right-click the
                            <span class="text-white d-inline-flex align-items-center" style="gap: 4px;">Trovve icon
                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                                    <path d="M11.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill="#5059C9"></path>
                                    <path d="M17.5 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" fill="#7B83EB"></path>
                                    <path d="M20.5 12h-6a1 1 0 0 0-1 1v5.5A3.5 3.5 0 0 0 17 22a3.5 3.5 0 0 0 3.5-3.5V13a1 1 0 0 0-1-1Z" fill="#7B83EB"></path>
                                    <path d="M14.5 12H5a1 1 0 0 0-1 1v6a4.5 4.5 0 0 0 9 0v-6a1 1 0 0 0-1-1Z" fill="#4B53BC"></path>
                                </svg>
                            </span>
                            in the Teams sidebar
                        </p>
                    </div>
                    <div class="d-flex align-items-start">
                        <div class="pin-ob-step-num flex-shrink-0">2</div>
                        <p class="f-size-12 mb-0" style="color: rgba(255,255,255,0.75); line-height: 1.5;">
                            Select <span class="text-white">Pin</span> — Trovve stays in your Teams menu
                        </p>
                    </div>
                </div>
                <div class="pin-ob-side-footer">
                    Takes 2 seconds — saves you searching every time
                </div>
            </div>
        </div>
    </div>

    <!-- Main popup - Welcome card (centered) -->
    <div class="pin-ob-main-popup">
        <div class="pin-ob-main-card">
            <div class="d-flex align-items-center justify-content-between px-20 py-3" style="border-bottom: 1px solid #e5e7eb;">
                <img src="https://cdn.trovve.com/trovve/OB_Trovve_Logo.svg" alt="Trovve" style="height: 20px; object-fit: contain;">
                <button class="pin-ob-main-close" aria-label="Close" (click)="closePinOBModal()">
                    <lucide-icon name="x" [size]="16" [strokeWidth]="2" style="color: #9ca3af;"></lucide-icon>
                </button>
            </div>
            <div class="px-20 pt-20 pb-3">
                <h2 class="f-size-20 text-vf-dark mb-1 font-weight-medium">You're in</h2>
                <p class="f-size-14 mb-20" style="color: #6b7280; line-height: 1.5;">Trovve is set up and ready. Here's how to get started.</p>

                <div class="mb-20">
                    <div class="d-flex align-items-start mb-12" style="gap: 12px;">
                        <div class="pin-ob-feature-icon flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4b5563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="4"></circle>
                                <path d="M12 2v2"></path><path d="M12 20v2"></path>
                                <path d="m4.93 4.93 1.41 1.41"></path><path d="m17.66 17.66 1.41 1.41"></path>
                                <path d="M2 12h2"></path><path d="M20 12h2"></path>
                                <path d="m6.34 17.66-1.41 1.41"></path><path d="m19.07 4.93-1.41 1.41"></path>
                            </svg>
                        </div>
                        <div>
                            <p class="f-size-14 text-vf-dark mb-0 font-weight-medium">My Day shows what's due</p>
                            <p class="f-size-12 mb-0 mt-1" style="color: #6b7280; line-height: 1.5;">Tasks from your {{projectLabelPluralLower}} surface here automatically, filtered to today and this week.</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-start" style="gap: 12px;">
                        <div class="pin-ob-feature-icon flex-shrink-0">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4b5563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                            </svg>
                        </div>
                        <div>
                            <p class="f-size-14 text-vf-dark mb-0 font-weight-medium">{{projectLabelPlural}} keep work structured</p>
                            <p class="f-size-12 mb-0 mt-1" style="color: #6b7280; line-height: 1.5;">Assign tasks to {{projectLabelPluralLower}} and clients — everything stays organized and traceable.</p>
                        </div>
                    </div>
                </div>

                <!-- Pin reminder callout -->
                <div class="pin-ob-callout mb-20" *ngIf="isIframe">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="flex-shrink-0">
                            <path d="M11.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill="#5059C9"></path>
                            <path d="M17.5 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" fill="#7B83EB"></path>
                            <path d="M20.5 12h-6a1 1 0 0 0-1 1v5.5A3.5 3.5 0 0 0 17 22a3.5 3.5 0 0 0 3.5-3.5V13a1 1 0 0 0-1-1Z" fill="#7B83EB"></path>
                            <path d="M14.5 12H5a1 1 0 0 0-1 1v6a4.5 4.5 0 0 0 9 0v-6a1 1 0 0 0-1-1Z" fill="#4B53BC"></path>
                        </svg>
                        <p class="f-size-12 mb-0" style="color: #92400e; line-height: 1.5;">
                            <span style="color: #78350f; font-weight: 500;">Pin Trovve in Teams</span> — right-click the Trovve icon in the Teams sidebar and select <span style="color: #78350f; font-weight: 500;">Pin</span> so you never lose it.
                        </p>
                    </div>
                </div>

                <button class="btn btn-black w-100 f-size-14 font-weight-medium rounded-4" style="height: 36px;"
                    (click)="closePinOBModal()">Let's go</button>
            </div>
        </div>
    </div>
</ng-container>

